// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"

import CSRF from "csrf-xhr/csrf-xhr.js"
Rails.start()
ActiveStorage.start()

require("@popperjs/core")

// The stylesheet location we created earlier
require("../stylesheets/application.scss")
import 'bootstrap-icons/font/bootstrap-icons.css'
import "bootstrap"
